// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/shared/SpoilerOverlay.module.css';
import FocusRing from '@app/features/ui/focus_ring/FocusRing';
import {useLingui} from '@lingui/react/macro';
import {clsx} from 'clsx';
import type {FC, ReactNode} from 'react';

interface SpoilerOverlayProps {
	hidden: boolean;
	onReveal: () => void;
	children: ReactNode;
	label?: string;
	inline?: boolean;
	className?: string;
}
export const SpoilerOverlay: FC<SpoilerOverlayProps> = ({hidden, onReveal, children, label, inline, className}) => {
	const {t} = useLingui();
	const ariaLabel = label ?? t`Reveal spoiler`;
	return (
		<div className={clsx(styles.container, inline && styles.inline, hidden && styles.hidden, className)}>
			<div className={styles.content} aria-hidden={hidden}>
				{children}
			</div>
			{hidden && (
				<FocusRing offset={-2}>
					<button type="button" className={styles.overlayButton} onClick={onReveal} aria-label={ariaLabel}>
						<span className={styles.overlayLabel}>{label ?? t`Spoiler`}</span>
					</button>
				</FocusRing>
			)}
		</div>
	);
};
